import { Component, Input } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../globals';
import { InvoicesServices } from '../services';

/**
 * Generated class for the TpvTicketSelectedListTicketPrintPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
    selector: 'page-invoices-ticket-print',
    templateUrl: 'invoices-ticket-print.html',
})
export class InvoicesTicketPrintPage {
    @Input() selected_list: any;
    footer: any;
    header: any;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public globals: Globals,
        public invoicesServices:InvoicesServices) {

    }

}



// WEBPACK FOOTER //
// ./src/pages/invoices/invoices-ticket-print/invoices-ticket-print.ts